import { defineComponent as _defineComponent } from 'vue'
import { makeFormModel, getChildModel, setState, updateModel } from 'ah-common-lib/src/form/helpers';
import { checkboxField } from 'ah-common-lib/src/form/models';
import { ClientType, CompanyRegistrationModel, ExportFileType, LegalFileType } from 'ah-api-gateways';
import { FormDefinition, FormValidation } from 'ah-common-lib/src/form/interfaces';
import { computed, onBeforeMount, reactive, ref, watch } from 'vue';
import { useTheme } from 'ah-theme';
import { useAuthStore } from '@/app/store/authModule';
import { getServices } from '@/app/services';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { LoadingIcon } from 'ah-common-lib/src/icons/components';
import { forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';


export default /*#__PURE__*/_defineComponent({
  __name: 'TermsAcceptanceForm',
  props: {
    model: null
  },
  emits: ["update:validation"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:validation', value: FormValidation): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { model?: Partial<CompanyRegistrationModel> };



const requestManager = useRequestManager().manager;

const services = getServices();



const authStore = useAuthStore();

const TOSHtml = computed(() => selectedFile.value?.html ?? '');

const termsFiles = ref<{ type: LegalFileType; label: string; html: string }[]>([
  {
    type: LegalFileType.TOS_PAYMENT_SERVICE,
    label: 'Payment Services',
    html: '',
  },
  {
    type: LegalFileType.TOS,
    label: 'Terms and Conditions',
    html: '',
  },
]);

const selectedFileType = ref<LegalFileType>(termsFiles.value[0].type);

const selectedFile = computed(() => termsFiles.value.find((i) => i.type === selectedFileType.value));

onBeforeMount(() => {
  requestManager
    .sameOrCancelAndNew(
      'getTOSHtml',
      forkJoin(
        termsFiles.value.map((i) =>
          services.customerReference.getLegalDocument(i.type, ExportFileType.HTML).pipe(
            map((r) => ({
              type: i.type,
              label: i.label,
              html: r.html,
            }))
          )
        )
      )
    )
    .subscribe((res) => (termsFiles.value = res));
});

const termsAndConditionsFM = reactive<FormDefinition>({
  form: makeFormModel({
    name: 'termsAndConditions',
    fieldType: 'form',
    fields: [
      checkboxField('paymentServices', 'I confirm I have read and agree with the Payment Services.', false, {
        required: true,
        errorMessages: {
          mustAccept: 'Must agree with the Payment Services to continue',
        },
      }),
      checkboxField('termsAndConditions', 'I confirm I have read and agree with to Terms and Conditions.', false, {
        required: true,
        errorMessages: {
          mustAccept: 'Must agree with the Terms and Conditions to continue',
        },
      }),
    ],
  }),
  validation: null,
});

function downloadTerms() {
  requestManager
    .sameOrCancelAndNew(
      'downloadTerms',
      services.customerReference.downloadLegalDocument(selectedFileType.value, ExportFileType.PDF)
    )
    .subscribe();
}

const information = computed(() => {
  return `${useTheme().val.name} are partnered with ALT21. Your data will be processed by ALT21
   in accordance with Data Protection legislation for the purposes of client
    administration and will be maintained in line with our retention policy.
    Further information about your privacy can be located here.`;
});

const validation = computed(() => {
  return {
    $model: termsAndConditionsFM.form.termsAndCondition && termsAndConditionsFM.form.paymentServices,
    $invalid: termsAndConditionsFM.validation?.$invalid,
    $dirty: termsAndConditionsFM.validation?.$dirty,
  } as FormValidation;
});

const isOwner = computed(() => {
  return (
    !authStore.isClientUser ||
    authStore.loggedInIdentity?.client?.type !== ClientType.COMPANY ||
    authStore.loggedInIdentity?.owner
  );
});

watch(
  () => props.model,
  () => {
    updateModel(termsAndConditionsFM.form, props.model ?? {});
    setState(getChildModel(termsAndConditionsFM.form, 'termsAndConditions')!, 'hidden', !isOwner.value);
  },
  { immediate: true }
);

watch(validation, () => emit('update:validation', validation.value), { immediate: true });

return { __sfc: true,props, requestManager, services, emit, authStore, TOSHtml, termsFiles, selectedFileType, selectedFile, termsAndConditionsFM, downloadTerms, information, validation, isOwner, LoadingIcon }
}

})